import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const AnchorSVG = () => (
  <svg width="22" height="22" viewBox="0 0 40 52" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="20" cy="7" r="5" stroke="currentColor" strokeWidth="1.5" fill="none"/>
    <circle cx="20" cy="7" r="2" fill="currentColor"/>
    <line x1="4" y1="14" x2="36" y2="14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    <line x1="20" y1="12" x2="20" y2="40" stroke="currentColor" strokeWidth="1.5"/>
    <path d="M20 40 C13 38 5 33 5 26" stroke="currentColor" strokeWidth="1.5" fill="none" strokeLinecap="round"/>
    <path d="M20 40 C27 38 35 33 35 26" stroke="currentColor" strokeWidth="1.5" fill="none" strokeLinecap="round"/>
    <path d="M5 26 C5 46 35 46 35 26" stroke="currentColor" strokeWidth="1.5" fill="none"/>
  </svg>
);

const Navigation: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isAtTop, setIsAtTop] = useState(true);
  const location = useLocation();
  const isHome = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => setIsAtTop(window.scrollY < 60);
    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Close mobile menu on route change
  useEffect(() => {
    setIsMenuOpen(false);
  }, [location]);

  const navClass = [
    'navigation',
    isHome && isAtTop ? 'navigation--home-top' : ''
  ].filter(Boolean).join(' ');

  return (
    <>
      <nav className={navClass}>
        <Link to="/" className="nav-logo">
          Ashley &amp; A.J.
        </Link>

        <ul className="nav-menu">
          <li><Link to="/story"      className={location.pathname === '/story'      ? 'active' : ''}>Our Story</Link></li>
          <li><Link to="/details"    className={location.pathname === '/details'    ? 'active' : ''}>Details</Link></li>
          <li><Link to="/afterparty" className={location.pathname === '/afterparty' ? 'active' : ''}>Afterparty</Link></li>
          <li><Link to="/registry"   className={location.pathname === '/registry'   ? 'active' : ''}>Registry</Link></li>
          <li><Link to="/qa"         className={location.pathname === '/qa'         ? 'active' : ''}>Q &amp; A</Link></li>
        </ul>

        <button
          className={`hamburger ${isMenuOpen ? 'open' : ''}`}
          onClick={() => setIsMenuOpen(v => !v)}
          aria-label="Toggle menu"
        >
          <span></span><span></span><span></span>
        </button>
      </nav>

      {/* Mobile menu */}
      <div className={`nav-mobile ${isMenuOpen ? 'nav-mobile--open' : ''}`}>
        <Link to="/story"      onClick={() => setIsMenuOpen(false)}>Our Story</Link>
        <Link to="/details"    onClick={() => setIsMenuOpen(false)}>Details</Link>
        <Link to="/afterparty" onClick={() => setIsMenuOpen(false)}>Afterparty</Link>
        <Link to="/registry"   onClick={() => setIsMenuOpen(false)}>Registry</Link>
        <Link to="/qa"         onClick={() => setIsMenuOpen(false)}>Q &amp; A</Link>
      </div>
    </>
  );
};

export default Navigation;
